export default __webpack_public_path__ + "static/media/logoimg.cd4bfc7c.png";